import { createAction, props } from '@ngrx/store';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';

export const addUserPage = createAction('[Account Permission Page] Add User');
export const loadAccountUsers = createAction('[Account Permission Page] Load Account Users');
export const loadClientSegmentContent = createAction(
    '[Account Permission Page] Load Client Segment Content',
);
export const loadDefaultClientSegmentContent = createAction(
    '[Account Permission Page] Load default Client Segment Content',
    props<{ data: ClientSegmentContentDTO }>(),
);
